export default __webpack_public_path__ + "static/media/icon-cocktail.1b203455.svg";